import { Navigate, useNavigate } from 'react-router';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ITokenUserFragment, IRole } from 'graphql/types';
import { CoverPage } from 'hydra/pages/CoverPage';
import { Typography } from 'common/components/Typography';
import { Text } from 'common/components/Text';
import { ChangePassword } from 'user/components/ChangePassword';
import { TokenLogin } from 'user/components/TokenLogin';
import { getUrl } from 'route/utils/getUrl';
import { PageTitle } from 'common/components/PageTitle';

export const WelcomePage = () => {
    const { t: translate } = useTranslation();
    const navigate = useNavigate();

    const renderContent = (tokenUser: ITokenUserFragment) => {
        const userRoles = tokenUser?.roles || [];

        const isOwner = userRoles.includes(IRole.Owner);
        const redirectUrl = isOwner ? 'ORGANISATION_LANGUAGE' : 'HOME';

        if (tokenUser.hasPassword) {
            return <Navigate to={getUrl(redirectUrl)} />;
        }

        const titleKey = isOwner ? 'titleOwner' : 'title';
        const contentKey = isOwner ? 'contentOwner' : 'content';

        return (
            <>
                <PageTitle>{translate(`welcomePage.${titleKey}`)}</PageTitle>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h2">
                        {translate(`welcomePage.${titleKey}`)}
                    </Typography>
                </Box>
                <Text>{translate(`welcomePage.${contentKey}`)}</Text>
                <ChangePassword
                    onSuccess={async () => {
                        navigate(getUrl(redirectUrl));
                    }}
                />
            </>
        );
    };

    return (
        <CoverPage>
            <TokenLogin forPage="welcome">
                {(tokenUser) => renderContent(tokenUser)}
            </TokenLogin>
        </CoverPage>
    );
};
